export const ReadingFormat = {
  PHYSICAL: "physical",
  EBOOK: "ebook",
  AUDIOBOOK: "audiobook",
};

export const ReadingFormatLabels = {
  [ReadingFormat.PHYSICAL]: "Physical",
  [ReadingFormat.EBOOK]: "E-book",
  [ReadingFormat.AUDIOBOOK]: "Audiobook",
};

export const ReadingFormatIcons = {
  [ReadingFormat.PHYSICAL]: "📖",
  [ReadingFormat.EBOOK]: "📱",
  [ReadingFormat.AUDIOBOOK]: "🎧",
};
